import { buildMessage, registerDecorator } from 'class-validator';
export function isLessThan(value, relatedValue) {
    return typeof value === 'number' && value < relatedValue;
}
export function IsLessThan(property, validationOptions) {
    return function IsLessThanDecorator(object, propertyName) {
        registerDecorator({
            name: isLessThan.name,
            target: object.constructor,
            propertyName: propertyName.toString(),
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value, args) {
                    const [relatedPropertyName] = args.constraints;
                    const relatedValue = args.object[relatedPropertyName];
                    return isLessThan(value, relatedValue);
                },
                defaultMessage: buildMessage((eachPrefix) => {
                    return `${eachPrefix}$property must be less than ${property}`;
                }, validationOptions),
            },
        });
    };
}
//# sourceMappingURL=IsLessThan.js.map